import { render, staticRenderFns } from "./ShouninRoutePage.vue?vue&type=template&id=edab5f8a&scoped=true&"
import script from "./ShouninRoutePage.vue?vue&type=script&lang=ts&"
export * from "./ShouninRoutePage.vue?vue&type=script&lang=ts&"
import style0 from "./ShouninRoutePage.vue?vue&type=style&index=0&id=edab5f8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edab5f8a",
  null
  
)

export default component.exports